import React from "react"

import Logo from "./logo"

const Billboard = () => {
  return (
    <div style={{ width: "100%", height: "auto" }}>
      <Logo />
    </div>
  )
}

export default Billboard
